import { useRef, useState, useEffect } from 'preact/hooks'
import { PauseIcon } from '../placeholder/icons/PauseIcon'
import { PlayIcon } from '../placeholder/icons/PlayIcon'
import { types as VideoTypes } from './types'
import styles from './Video.module.scss'

export default function Video({
    url = null,
    config: { auto_play = false } = {}
}: VideoTypes) {
    const reducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches

    const [isPlaying, setIsPlaying] = useState(auto_play && !reducedMotion)
    const videoRef = useRef(null)

    useEffect(() => {
        const videoElement = videoRef.current
        if (reducedMotion) {
            videoElement.pause()
        }
    }, [reducedMotion])

    if (!url) {
        return null
    }

    const togglePlayPause = () => {
        const videoElement = videoRef.current

        if (isPlaying) {
            videoElement.pause()
        } else {
            videoElement.play()
        }

        setIsPlaying(!isPlaying)
    }

    return (
        <div className={styles['video-container']}>
            <video ref={videoRef} playsInline autoPlay={auto_play} muted loop>
                <source src={url} type="video/mp4"></source>
            </video>

            <button
                id="autoplay-toggle"
                className={styles['video-autoplay-button']}
                aria-pressed={isPlaying}
                aria-label={isPlaying ? 'Pause video' : 'Play video'}
                onClick={togglePlayPause}>
                <span>
                    {isPlaying ? (
                        <PauseIcon fillRect="white" />
                    ) : (
                        <PlayIcon fillRect="white" />
                    )}
                </span>
            </button>
        </div>
    )
}
